import './UsageStatisticsReport.css';

import { useEffect } from 'react';

import { HistoricalReportTable } from '../HistoricalReportTable';
import { NewUsageStatisticsReport } from './NewUsageStatisticsReport';

function UsageStatisticsReport({
  // functions
  generateUsageReport,
  getUsageReports,
  // state
  usageStatisticsReports,
  usageStatisticsReportsIsLoading,
}) {
  useEffect(() => {
    getUsageReports();
  }, []);

  return (
    <>
      <div className="usage-statistics-report">
        <hr />
        <div>
          <h2>Usage Statistics Report</h2>
          <NewUsageStatisticsReport
            reports={usageStatisticsReports}
            generateUsageReport={generateUsageReport}
            usageStatisticsReportsIsLoading={usageStatisticsReportsIsLoading}
          />
        </div>

        <div>
          <h4 style={{ marginTop: '50px' }}>Usage Report History</h4>
          <HistoricalReportTable
            reports={usageStatisticsReports}
            loading={usageStatisticsReportsIsLoading}
            columns={[
              'id',
              'status',
              'createdAtParsed',
              'fromDate',
              'untilDate',
              'link',
            ]}
          />
        </div>
      </div>
    </>
  );
}

export default UsageStatisticsReport;
